import SecureBaseModel from './SecureBaseModel';

class ActivityModel extends SecureBaseModel {

    //These have to match with the routes in backend > APIController
    static ACTIVITY = 'activity';

    constructor() {
        super();
    }

    async logActivity(params) {
        return await this.postData(ActivityModel.ACTIVITY, params);
    }
}

export default ActivityModel;